import { types } from '@redux/actions/bank';
import { bankLoginStatuses } from '@constants';

const initialState = {
  loginSession: {
    sessionId: '',
    provider: '',
    status: '',
    message: '',
    token: '', // TODO: Is this usefull ?
    parameters: {},
    error: false,
  },
  reportId: '',
  accounts: [],
  startSessionLoading: false,
  retrieveDataLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.BANK_RESET:
    case types.START_BANK_LOGIN_SESSION_FAILURE:
      return initialState;
    case types.RESTORE_BANK_LOGIN_SESSION:
      return {
        ...state,
        loginSession: {
          ...state.loginSession,
          ...action.sessionData,
        },
      };
    case types.START_BANK_LOGIN_SESSION:
      return {
        ...state,
        loginSession: {
          ...state.loginSession,
          provider: action.provider,
          status: bankLoginStatuses.STARTED,
          parameters: action.parameters,
        },
        startSessionLoading: true,
      };
    case types.START_BANK_LOGIN_SESSION_SUCCESS:
      return {
        ...state,
        loginSession: {
          ...state.loginSession,
          sessionId: action.sessionId,
        },
        startSessionLoading: false,
      };
    case types.UPDATE_BANK_LOGIN_SESSION:
      return {
        ...state,
        loginSession: {
          ...state.loginSession,
          status: action.status,
          message: action.message,
          token: action.token,
        },
      };
    case types.RETRIEVE_BANK_DATA:
      return {
        ...state,
        loginSession: {
          ...state.loginSession,
          error: false,
        },
        retrieveDataLoading: true,
      };
    case types.RETRIEVE_BANK_DATA_SUCCESS:
      return {
        ...state,
        accounts: action.accounts,
        reportId: action.reportId,
        retrieveDataLoading: false,
      };
    case types.RETRIEVE_BANK_DATA_FAILURE:
      return {
        ...state,
        accounts: initialState.accounts,
        reportId: initialState.reportId,
        loginSession: {
          ...state.loginSession,
          error: true,
        },
        retrieveDataLoading: false,
      };
    case types.BANK_LOGIN_SESSION_RESET:
      return {
        ...state,
        loginSession: initialState.loginSession,
      };
    default:
      return state;
  }
};

export const loginSessionSelector = (state) => state.bank.loginSession;
